import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {Bel} from "../../../common/services/bel/bel/bel.model";
import {MatAccordion} from "@angular/material/expansion";
import {BelService} from "../../../common/services/bel/bel/bel.service";
import {SubSink} from '@Common/core/utils/subsink';
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-informations-complementaires',
  templateUrl: './informations-complementaires.component.html',
  styleUrls: ['./informations-complementaires.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InformationsComplementairesComponent implements OnInit {
  @Input() Bel: Bel;
  @Input() edition_mode = false;
  @Input() refresh_list = false;
  @Output() refreshEvent = new EventEmitter<boolean>();
  @ViewChild(MatAccordion) entities: MatAccordion;
  SubSink = new SubSink();
  datas$ = new BehaviorSubject<{}>({});
  constructor(private belSvc: BelService) { }

  ngOnInit(): void {
      this._getEntitesInfosComps();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes?.refresh_list && changes?.refresh_list.currentValue){
      this._getEntitesInfosComps(true);
    }
  }

  private _getEntitesInfosComps(emit_event=false):void {
      this.SubSink.sink = this.belSvc.getEntitesInstructionsInforamtionsComplementaires(this.Bel).subscribe((_data) => {
          this.datas$.next(_data['data']);
          if(emit_event){
            this.refreshEvent.emit(false);
          }
      });
  }

  protected readonly Object = Object;
}
